import { Link } from "react-router-dom";
import Marquee from "./Marquee";
import { useLang } from "../i18n";

const WORDS = [
  { en: "Lost-Wax Casting", it: "Fusione a Cera Persa" },
  { en: "Gemstone Setting", it: "Incastonatura" },
  { en: "Hand Engraving", it: "Incisione a Mano" },
  { en: "Wax Carving", it: "Scultura in Cera" },
  { en: "CAD Modelling", it: "Progettazione CAD" },
  { en: "3D Prototyping", it: "Prototipazione 3D" },
];

export function EditorialMarquee() {
  const { L } = useLang();
  return (
    <div className="border-y hairline py-6" data-testid="editorial-marquee">
      <Marquee duration={80}>
        {WORDS.map((w, i) => (
          <span key={i} className="mx-10 flex items-center gap-10">
            <span className="font-display text-2xl italic text-[#8A8F82] sm:text-3xl">{L(w)}</span>
            <span className="text-[#C9A84C]">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}

export default function Footer() {
  const { L } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#0E3B33] text-[#F1ECDD]">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-baseline gap-2.5">
              <span className="font-display text-3xl leading-none tracking-tight">DA</span>
              <span className="mono-tech text-[#C9A84C]">Creations Atelier</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#F1ECDD]/60">
              {L({
                en: "Artisan jewellery casting lab — Urbino, Marche, Italy. Metal invoiced at live market spot, always.",
                it: "Laboratorio artigianale di fusione — Urbino, Marche, Italia. Metallo fatturato sempre alla quotazione live di mercato.",
              })}
            </p>
          </div>
          <div>
            <div className="mono-tech mb-4 text-[#C9A84C]">{L({ en: "Services", it: "Servizi" })}</div>
            <ul className="space-y-2.5 text-sm text-[#F1ECDD]/75">
              <li>
                <Link data-testid="footer-link-casting-italy" to="/jewelry-casting-italy/" className="transition-colors hover:text-[#C9A84C]">
                  {L({ en: "Jewellery casting in Italy", it: "Fusione di gioielli in Italia" })}
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-lost-wax" to="/lost-wax-casting-jewelry/" className="transition-colors hover:text-[#C9A84C]">
                  {L({ en: "Lost-wax casting", it: "Fusione a cera persa" })}
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-private-label" to="/private-label-jewelry-italy/" className="transition-colors hover:text-[#C9A84C]">
                  {L({ en: "Private label manufacturing", it: "Produzione private label" })}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <div className="mono-tech mb-4 text-[#C9A84C]">{L({ en: "Contact", it: "Contatti" })}</div>
            <ul className="space-y-2.5 text-sm text-[#F1ECDD]/75">
              <li><a data-testid="footer-phone" href="tel:+393716159381" className="transition-colors hover:text-[#C9A84C]">+39 371 615 9381</a></li>
              <li><a data-testid="footer-email" href="mailto:daniela@da-creations.com" className="transition-colors hover:text-[#C9A84C]">daniela@da-creations.com</a></li>
              <li><a data-testid="footer-instagram" href="https://instagram.com/dacreationsatelier" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-[#C9A84C]">@dacreationsatelier</a></li>
            </ul>
          </div>
          <div>
            <div className="mono-tech mb-4 text-[#C9A84C]">{L({ en: "Atelier", it: "Atelier" })}</div>
            <ul className="space-y-2.5 text-sm text-[#F1ECDD]/75">
              <li>Urbino, 61029 PU — Marche, Italy</li>
              <li>{L({ en: "Mon–Fri 9:00–18:00 · Sat by appointment", it: "Lun–Ven 9:00–18:00 · Sab su appuntamento" })}</li>
              <li>
                <a data-testid="footer-brochure" href="https://da-creations.com/wp-content/uploads/2025/11/DAcreations-brochure.pdf" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-[#C9A84C]">
                  {L({ en: "Download brochure", it: "Scarica la brochure" })}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs text-[#F1ECDD]/45 sm:flex-row sm:items-center">
          <span>© {new Date().getFullYear()} DA Creations Atelier — {L({ en: "Made in Italy with passion.", it: "Fatto in Italia con passione." })}</span>
          <span className="mono-tech">Urbino, Marche</span>
        </div>
      </div>
    </footer>
  );
}
